export interface IDashPwlJugBilling {
    id:number, 
    centerId?:number, 
    statusId:number,
    status:string,
    trackingNumber:string, 
    isJugOnlyRequest:boolean
    requestedDateTime:string, 
    shippedDateTime:string, 
    arrivalDateTime:string, 
    notFoundDateTime:string, 
    registrationId:number,
    shipToName:string, 
    shipToAddressLine1:string, 
    shipToCity:string, 
    state:number, 
    shipToState:string,
    shipToPostalCode:string, 
    currentRegistrationStep:number, 
    donorRegistrationStep:string,
    isOptedOut:string, 
    registrationFullName:string, 
    registrationDob:string,
    gender?:number, 
    registrationGender:string
}